import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Button } from 'core-components/library/button'
import { Menu } from 'core-components/library/menu'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { BaseCrud, Static } from 'core-components/types'

import styles from './ActionsSelector.module.scss'

interface IActionsSelector {
  onChoose: (id: string) => void
}

export const ActionsSelector = ({ onChoose }: IActionsSelector) => {
  const user = useSelector(selectUser)
  const isAdmin = useMemo(() => user.roleIds.includes('SuperAdmin'), [user.roleIds])

  const crudMenu = useMemo(() => {
    let menuLis = [
      {
        id: 'toDefault',
        label: 'Reset to default',
      },
      {
        id: 'import-settings',
        label: 'Import page settings',
      },
      {
        id: 'export-settings',
        label: 'Export page settings',
      },
    ]
    if (isAdmin) {
      menuLis = menuLis
        .slice(0, 1)
        .concat({
          id: 'save',
          label: 'Save as default',
        })
        .concat(menuLis.slice(1))
    }
    return new BaseCrud({
      fetcher: new Static(menuLis),
      keyField: 'id',
    })
  }, [isAdmin])

  return (
    <Menu
      classes={{
        root: styles.dotsMenu,
      }}
      __popupTestId={'layoutActionsPopup'}
      subMenuClasses={{
        row: styles.dotsMenu__row,
        cell: styles.dotsMenu__cell,
        iconCell: styles.dotsMenu__iconCell,
      }}
      content={() => (
        <Button
          variant={'text'}
          color={'grey'}
          iconButton={'kbase kbase-menu-dots'}
          __testId={'layoutActionsListButton'}
        />
      )}
      source={crudMenu}
      caption={'label'}
      onChoose={onChoose}
    />
  )
}
